<template>
	<div style="min-height:700px">这是平台服务</div>
</template>
<script>
export default {
    name: "platformservice",
    data() {
        return {};
    }
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/platformservice.vue